webpackJsonp([1],{

/***/ "9+e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__ = __webpack_require__("iAG1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_758ba5a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__ = __webpack_require__("H4Nr");
function injectStyle (ssrContext) {
  __webpack_require__("ha7V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-758ba5a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_758ba5a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AqYs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "H4Nr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid",style:(_vm.styleObject)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97e6002a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("gMsX");
function injectStyle (ssrContext) {
  __webpack_require__("ROnl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97e6002a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "ROnl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gMsX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styleObject),attrs:{"id":"app"},on:{"mousemove":_vm.onMousemove,"click":_vm.onMouseclick}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.grids),function(griditema,i){return _c('div',_vm._l((griditema),function(griditemb,j){return _c('div',[_c('Grid',{attrs:{"pos-x":_vm.posX,"pos-y":_vm.posY,"g-zoom":_vm.gZoom,"window-width":_vm.windowWidth,"window-height":_vm.windowHeight,"prx":_vm.grids[i][j][0],"pry":_vm.grids[i][j][1]}})],1)}),0)}),_vm._v(" "),_c('div',{staticClass:"metrics"},[_c('div',[_vm._v("MOUSE X:"+_vm._s(_vm.posX))]),_vm._v(" "),_c('div',[_vm._v("MOUSE Y:"+_vm._s(_vm.posY))]),_vm._v(" "),_c('div',[_vm._v("Color"+_vm._s(_vm.tweenedCSSColor))]),_vm._v(" "),_c('div',[_vm._v("Zoom:"+_vm._s(_vm.gZoom))])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('h1',[_c('img',{attrs:{"src":__webpack_require__("AqYs"),"alt":"sainome.com","width":"184","height":"22"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info"},[_c('a',{attrs:{"href":"mailto:info@sainome.com"}},[_vm._v("info@sainome.com")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ha7V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iAG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_color_js__ = __webpack_require__("Njim");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_color_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_color_js__);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Grid',
  props: {
    posX: Number,
    posY: Number,
    gZoom: Number,
    prx: Number,
    pry: Number,
    windowWidth: Number,
    windowHeight: Number
  },
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      color: '#000',
      top: -500,
      left: -500,
      w: 20,
      h: 20,
      px: 0,
      py: 0,
      pz: 0,
      spx: 0,
      spy: 0,
      spz: 0,
      // ox: 0, defined in computed
      // oy: 0, defined in computed
      oz: 0,
      op: 0,
      vx: 3 * Math.PI / 180,
      vy: 0,
      vz: 0
    };
  },

  created: function created() {
    this.color = new __WEBPACK_IMPORTED_MODULE_0_color_js___default.a({
      red: Math.random(),
      green: Math.random(),
      blue: Math.random(),
      alpha: 1
    }).toCSS();
    this.px = this.prx;
    this.py = this.pry;
    this.spx = this.gZoom * this.px;
    this.spy = this.gZoom * this.py;
    this.spz = this.gZoom * this.pz;
    this.oz = 210;
    this.op = 400;
  },
  mounted: function mounted() {
    this.$parent.$on('enterFrame', this.rotate);
  },
  methods: {
    rot: function rot() {
      var tempa = void 0,
          tempb = void 0;
      tempa = this.py * Math.cos(this.vx) - this.pz * Math.sin(this.vx);
      tempb = this.pz * Math.cos(this.vx) + this.py * Math.sin(this.vx);
      this.py = tempa;
      this.pz = tempb;

      tempa = this.px * Math.cos(this.vy) + this.pz * Math.sin(this.vy);
      tempb = this.pz * Math.cos(this.vy) - this.px * Math.sin(this.vy);
      this.px = tempa;
      this.pz = tempb;

      tempa = this.px * Math.cos(this.vz) - this.py * Math.sin(this.vz);
      tempb = this.py * Math.cos(this.vz) + this.px * Math.sin(this.vz);
      this.px = tempa;
      this.py = tempb;
    },
    spread: function spread() {
      this.spx = this.gZoom * this.px;
      this.spy = this.gZoom * this.py;
      this.spz = this.gZoom * this.pz;
    },
    perspective: function perspective() {
      var z = void 0;
      z = this.spz + this.oz;
      if (z > 0) {
        this.left = this.spx * this.op / z + this.ox - this.w / 2;
        this.top = -1 * (this.spy * this.op / z) + this.oy - this.h;
      }
    },
    vangle: function vangle() {
      var tempa = void 0,
          tempb = void 0;
      tempa = (this.ox - this.posY) / 20;
      if (tempa > 12) {
        tempa = 12;
      } else if (tempa < -12) {
        tempa = -12;
      }
      this.vx = -1 * tempa * Math.PI / 180;
      tempb = (this.oy - this.posX) / 20;
      if (tempb > 12) {
        tempb = 12;
      } else if (tempb < -12) {
        tempb = -12;
      }
      this.vy = -1 * tempb * Math.PI / 180;
    },
    rotate: function rotate() {
      this.rot();
      this.spread();
      this.perspective();
      this.vangle();
    }
  },
  computed: {
    ox: function ox() {
      return this.windowWidth / 2;
    },
    oy: function oy() {
      return this.windowHeight / 2;
    },
    styleObject: function styleObject() {
      var z = this.spz + this.oz;
      return {
        left: this.left + 'px',
        top: this.top + 'px',
        borderRadius: '4px',
        border: '1px solid' + this.color,
        width: this.w * this.op / z + 'px',
        height: this.h * this.op / z + 'px',
        zIndex: Math.floor(1000 - this.spz),
        opacity: 0.8
      };
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Grid__ = __webpack_require__("9+e2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js__ = __webpack_require__("pXIW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_color_js__ = __webpack_require__("Njim");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_color_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_color_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Grid: __WEBPACK_IMPORTED_MODULE_1__components_Grid__["a" /* default */]
  },
  data: function data() {
    return {
      msg: 'root',
      count: 0,
      number: 0,
      animatedNumber: 0,
      color: {
        red: 1,
        green: 1,
        blue: 1,
        alpha: 1
      },
      tweenedColor: {},
      posX: 0,
      posY: 0,
      gZoom: 2,
      gZoomBase: 0.8,
      gX: 500,
      gY: 500,
      gZ: 200,
      gP: 400,
      accel: 35,
      slow: 1.07,
      vx: 0,
      vxPlus: 0.2,
      grids: [],
      windowWidth: 0,
      windowHeight: 0
    };
  },

  created: function created() {
    this.color = new __WEBPACK_IMPORTED_MODULE_3_color_js___default.a({
      red: Math.random(),
      green: Math.random(),
      blue: Math.random(),
      alpha: 1
    });
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    this.tweenedColor = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.color);
    var sep = 35;
    var num = 7;
    var amplitude = Math.floor(num / 2);
    var _grid = new Array(num);
    for (var i = 0; i < num; i++) {
      _grid[i] = new Array(num);
    }
    for (var _i = 0; _i < num; _i++) {
      for (var j = 0; j < num; j++) {
        _grid[_i][j] = [sep * (-amplitude + j) + 1, sep * (amplitude - _i) - 1];
      }
    }
    this.grids = _grid;
  },
  mounted: function mounted() {
    console.log('msg is: ' + this.msg);
    requestAnimationFrame(this.enterFrame);
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  computed: {
    count2: function count2() {
      return this.count + 100;
    },
    tweenedCSSColor: function tweenedCSSColor() {
      return new __WEBPACK_IMPORTED_MODULE_3_color_js___default.a({
        red: this.tweenedColor.red,
        green: this.tweenedColor.green,
        blue: this.tweenedColor.blue,
        alpha: this.tweenedColor.alpha
      }).toCSS();
    },
    tweenedCSSColor2: function tweenedCSSColor2() {
      return new __WEBPACK_IMPORTED_MODULE_3_color_js___default.a({
        red: this.tweenedColor.red,
        green: this.tweenedColor.green,
        blue: this.tweenedColor.blue,
        alpha: this.tweenedColor.alpha
      }).shiftHue(30).darkenByRatio(0.3).toCSS();
    },
    styleObject: function styleObject() {
      return {
        background: 'linear-gradient(to bottom, ' + this.tweenedCSSColor + ', ' + this.tweenedCSSColor2 + ')'
      };
    }
  },
  methods: {
    enterFrame: function enterFrame(timestamp) {
      this.count++;
      this.restoreZoom();
      this.$emit('enterFrame');
      requestAnimationFrame(this.enterFrame);
    },
    restoreZoom: function restoreZoom() {
      this.vx = (this.vx + (this.gZoomBase - this.gZoom) / this.accel) / this.slow;
      this.gZoom += this.vx;
    },
    onMousemove: function onMousemove(event) {
      this.posX = event.clientX + 20;
      this.posY = event.clientY + 20;
    },
    onMouseclick: function onMouseclick(event) {
      this.number += 100;
      this.vx += this.vxPlus;
      this.color = new __WEBPACK_IMPORTED_MODULE_3_color_js___default.a({
        red: Math.random(),
        green: Math.random(),
        blue: Math.random(),
        alpha: 1
      }).toRGB();
      console.log('clicked');
    },
    onWindowResize: function onWindowResize(event) {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    }
  },
  watch: {
    number: function number(newValue, oldValue) {
      var _this = this;

      function animate() {
        if (__WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default.a.update()) {
          requestAnimationFrame(animate);
        }
      }
      new __WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default.a.Tween({ tweeningNumber: oldValue }).easing(__WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default.a.Easing.Quadratic.Out).to({ tweeningNumber: newValue }, 500).onUpdate(function (twn) {
        _this.animatedNumber = Number(twn.tweeningNumber.toFixed(0));
      }).start();
      animate();
    },
    color: function color() {
      function animate() {
        if (__WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default.a.update()) {
          requestAnimationFrame(animate);
        }
      }
      new __WEBPACK_IMPORTED_MODULE_2__tweenjs_tween_js___default.a.Tween(this.tweenedColor).to(this.color, 750).start();
      animate();
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.edd1f54d58a9eecbc5e5.js